import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import "./taskMainListTour.css";

function isMobileLayout() {
  if (typeof window === "undefined" || !window.matchMedia) return false;
  return window.matchMedia("(max-width: 1023px)").matches;
}

export function startTaskMainListTour() {
  const isMobile = isMobileLayout();
  const segments = [
    {
      selector: '[data-tour="tasks-header"]',
      title: "Tổng quan màn công việc",
      description:
        "Trang này quản lý toàn bộ luồng công việc theo trạng thái: chờ duyệt, đã duyệt, đã báo cáo và hoàn thành.",
      side: "bottom",
    },
    {
      selector: '[data-tour="tasks-filter"]',
      title: "Bộ lọc và thao tác nhanh",
      description:
        "Dùng bộ lọc để chọn khoảng ngày/nhân sự/phòng ban. Từ đây bạn có thể mở tạo công việc hoặc giao việc theo quyền.",
      side: "bottom",
    },
    {
      selector: '[data-tour="tasks-dashboard"]',
      title: "Dashboard trạng thái",
      description: isMobile
        ? "Nhấn từng tab để lọc nhanh theo trạng thái. Nhấn lại tab đang chọn để quay về xem toàn bộ."
        : "Nhấn từng thẻ trạng thái để lọc nhanh danh sách bên dưới. Nhấn lại thẻ đang chọn để bỏ lọc.",
      side: "bottom",
    },
    {
      selector: '[data-tour="tasks-list-sections"]',
      title: "Danh sách công việc",
      description:
        "Các nhóm công việc hiển thị theo trạng thái. Bấm vào card để mở popup chi tiết và thực hiện thao tác tiếp theo.",
      side: "top",
    },
    {
      selector: '[data-tour="tasks-completed"]',
      title: "Bảng công việc đã đóng",
      description:
        "Khu vực này tổng hợp công việc đã hoàn thành/chưa đạt. Bấm từng dòng để xem chi tiết kết quả.",
      side: "top",
    },
    {
      selector: '[data-tour="tasks-mobile-actions"]',
      title: "Nút nổi trên mobile",
      description:
        "Nút + để đăng ký công việc (giới hạn giờ 7:30-21:00), nút check để giao việc nếu bạn có quyền.",
      side: "left",
    },
  ];

  const steps = [
    {
      popover: {
        title: "Hướng dẫn sử dụng",
        description:
          "Vài bước giới thiệu nhanh cách lọc, theo dõi và thao tác công việc trên màn này.",
        side: "over",
        align: "center",
      },
    },
  ];

  for (const seg of segments) {
    const el = document.querySelector(seg.selector);
    if (!el) continue;
    steps.push({
      element: el,
      popover: {
        title: seg.title,
        description: seg.description,
        side: seg.side,
      },
    });
  }

  if (steps.length <= 1) {
    window.alert("Chưa tải đủ vùng giao diện để chạy hướng dẫn. Vui lòng thử lại.");
    return;
  }

  const d = driver({
    showProgress: true,
    smoothScroll: true,
    stagePadding: 10,
    stageRadius: 14,
    overlayOpacity: 0.68,
    overlayColor: "#0f172a",
    popoverClass: "task-main-list-tour-popover",
    onPopoverRender: (popover) => {
      popover.wrapper?.setAttribute?.("lang", "vi");
    },
    nextBtnText: "Tiếp",
    prevBtnText: "Trước",
    doneBtnText: "Xong",
    progressText: "Bước {{current}} / {{total}}",
    showButtons: ["next", "previous", "close"],
    steps,
  });

  d.drive();
}
